// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import browserHistory from 'react-router/lib/browserHistory';
import cx from 'classnames';
import appendLocale from '../../../helpers/appendLocale';
// Styles
import './OMTabs.scss';

class OMTabs extends Component {
  state = {
    activeTabKey: this.props.defaultActiveTabKey
  };

  componentWillReceiveProps({ defaultActiveTabKey }) {
    if (defaultActiveTabKey && defaultActiveTabKey !== this.props.defaultActiveTabKey) {
      this.setState({ activeTabKey: defaultActiveTabKey });
    }
  }

  handleSelect = (key) => {
    this.setState({ activeTabKey: key });
    if (this.props.onSelect) {
      this.props.onSelect(key);

      if (this.props.routeData && this.props.withLink) {
        const { location } = this.props.routeData;
        browserHistory.push(appendLocale(this.props.locale, `/${location}/${key}`));
      }
    }
  };

  renderTabHead = (props) => {
    const isActive = (props.id === this.state.activeTabKey);
    const title = (typeof props.title === 'function') ? props.title() : props.title;
    const handleSelect = () => !props.isDisabled && this.handleSelect(props.id);
    return (
      <div
        key={props.id}
        className={cx('om-tab', props.headerClassName, { 'active-om-tab': isActive, 'disabled-om-tab': props.isDisabled })}
        onClick={handleSelect}
      >
        <div className="om-tab-title">
          {title}
        </div>
      </div>
    );
  };

  renderTabHeads = () => this.props.children.filter(comp => !!comp).map(child => this.renderTabHead(child.props));

  renderChildren = () => React.Children.map(
    this.props.children.filter(comp => !!comp),
    (child) => {
      const isActive = (child.props.id === this.state.activeTabKey);
      const childProps = {
        _handleSelect: this.handleSelect,
        isActive,
        className: (!isActive) ? 'hidden-om-tab' : ''
      };
      return React.cloneElement(child, { ...childProps });
    }
  );

  render() {
    return (
      <div className={cx('om-tabs-container', this.props.className)}>
        <div className="om-tab-header">
          {this.renderTabHeads()}
        </div>
        <div className="om-tab-content">
          {this.renderChildren()}
        </div>
      </div>
    );
  }
}

OMTabs.propTypes = {
  onSelect: PropTypes.func,
  defaultActiveTabKey: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  className: PropTypes.string,
  children: PropTypes.array,
  withLink: PropTypes.bool,
  routeData: PropTypes.object,
  locale: PropTypes.string
};

export default OMTabs;
